import { FAQ_CUSTOMER_ERROR, FAQ_CUSTOMER_START, FAQ_CUSTOMER_SUCCESS } from "../Constant/TourFaqConstant";
  
  const initialState = {
    loading: false,
    data: []
  };
  
  export default function TourFaqReducer(
    state = { ...initialState },
    action
  ) {
    switch (action.type) {
      case FAQ_CUSTOMER_START:
        return {
          ...state,
          loading: true,
        };
      case FAQ_CUSTOMER_SUCCESS:
        return {
          ...state,
          data: action.payload,
          loading: false,
        };
      case FAQ_CUSTOMER_ERROR:
        return {
          ...state,
          loading: false,
          message: action.error.message,
        };
      default:
        return state;
    }
}
  